import { render, staticRenderFns } from "./SearchNoResults.vue?vue&type=template&id=23b66e37&scoped=true"
import script from "./SearchNoResults.vue?vue&type=script&lang=js"
export * from "./SearchNoResults.vue?vue&type=script&lang=js"
import style0 from "./SearchNoResults.vue?vue&type=style&index=0&id=23b66e37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b66e37",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LedSearchFormLicencePlate: require('/app/components/LedSearchFormLicencePlate.vue').default})
